<template>
    <div class="mt-4">
    <div class="d-flex justify-content-center mb-4 w-full">
      <div class="title">Bevétel</div>
    </div>
    <b-container v-if="selectedMode !== 'yearly'">
      <b-row class=" lead mb-2" >
        <b-col xl="3"></b-col>
        <b-col xl="5" class="column-title">Befolyt bevétel*</b-col>
        <b-col xl="4" class="column-title">Jövedelem*</b-col>
      </b-row>

      <b-row class="text-center pt-3 pb-3" :class="index != 2 ? '_border-bottom' : '' " v-for="(item, index) in selectedMonths" :key="index">
          <b-col v-if="!item.relevant" class="text-center" xl="3"><div class="month">{{ months[item.monthOrder] }}</div></b-col>
          <b-col v-if="!item.relevant" xl="9"><span>Nem releváns</span></b-col>
          <b-col v-if="item.relevant" class="text-center" xl="3"><div class="month">{{ months[item.monthOrder] }}</div></b-col>
          <b-col v-if="item.relevant" xl="5" class="text-style">{{  Number(item.bevetel).toLocaleString("hu-HU") }} Ft</b-col>
          <b-col v-if="item.relevant" xl="4" class="text-style">{{ Number(item.jovedelem).toLocaleString("hu-HU")  }} Ft</b-col>
      </b-row>

      <div class="my-4"/>
      <div class="footnote">* {{ $cte("flatRate.netAmount") }}</div>
    </b-container>
    <b-container v-if="selectedMode === 'yearly'" class="payable-margin">
      <div class="d-flex flex-column justify-content-between">
        <div class="text-style">Befolyt bevétel*</div>
        <div class="text-style">{{Number(selectedYear.bevetel).toLocaleString("hu-HU")}} Ft</div>
      </div>
      <div class="d-flex flex-column justify-content-between">
        <div class="text-style">Jövedelem*</div>
        <div class="text-style">{{Number(selectedYear.jovedelem).toLocaleString("hu-HU")}} Ft</div>
      </div>
      <div class="my-5"/>
      <div class="footnote">* {{ $cte("flatRate.netAmount") }}</div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "IncomeCard",

  props: ["selectedMode","selectedMonths", "selectedYear"],

  data() {
    return {
      months: [
        "Jan",
        "Febr",
        "Márc",
        "Ápr",
        "Máj",
        "Jún",
        "Júl",
        "Aug",
        "Szept",
        "Okt",
        "Nov",
        "Dec",
      ],
    };
  },
};
</script>

<style scoped>

.title {
  font-family: Jumper;
  color: #252734;
  font-size: 1.6rem;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}

.month {
  font-family: JumperLight;
  font-size: 12px;
  background-color: #b2ec5d;
  color: #252734;
  border-radius: 22px;
  padding: 5px;
}
.footnote {
  text-align: left;
  margin-right: 3rem;
  color: #b2ec5d;
  font-weight: bold;
  font-size: 0.9rem;
  bottom: 0;
}

.column-title {
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
}
.text-style {
  font-weight: 600;
  font-size: 16px;
  white-space: nowrap;
}

@media screen and (max-width: 1246px) {
  .text-style  {
    font-size: 30px;
  }
}
.payable-margin {
  margin-top: 65px;
}
@media screen and (max-width: 1246px) {
  .payable-margin {
    margin-top: 0px;
  }
}

</style>